import PurchaseRepository from "./purchase-repository";
import Purchase from "./purchase";
import { toPurchaseOrder } from "@/accounting/application/requests/purchase-order-request";

export default class PurchaseService {
  public constructor(private repository: PurchaseRepository) {}

  public async find(id: string): Promise<Purchase> {
    const purchase = await this.repository.find(Number(id));
    if (!purchase) {
      throw new Error("purchase is not found");
    }
    return toPurchaseOrder(purchase).toJSON();
  }

  /**
   * ステータスを変える
   */
  public async changeStatus(id: string, status: string): Promise<void> {
    const purchase = await this.repository.find(Number(id));
    if (!purchase) {
      throw new Error("purchase is not found");
    }
    purchase.status = status;
    await this.repository.save(purchase);
  }

  public calculate(data: Purchase): Purchase {
    return toPurchaseOrder(data).toJSON();
  }
}
